import {NewsPageMeta} from '@/src/features/news-articles/meta'

export {NewsPageMeta}
